import React, { forwardRef } from 'react';

import { IconColors } from './icon-utils';

export const AlineLogoIconPlain = forwardRef(function AlineLogoIconPlain(
  { className, fill = IconColors.White, ...rest }: { className?: string; fill?: string },
  ref: React.Ref<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      ref={ref}
      className={className}
      fill="none"
      height="36"
      viewBox="0 0 36 36"
      width="36"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        clipRule="evenodd"
        d="M19.0032 7.19775C17.9494 6.70636 16.6968 7.16228 16.2054 8.21607L13.5362 13.9402C13.0448 14.994 13.5007 16.2466 14.5545 16.738C15.6083 17.2294 16.8609 16.7735 17.3523 15.7197L20.0215 9.99555C20.5129 8.94176 20.057 7.68914 19.0032 7.19775ZM13.6648 18.6461C12.611 18.1547 11.3584 18.6106 10.867 19.6644L8.19775 25.3886C7.70636 26.4424 8.16228 27.695 9.21607 28.1864C10.2699 28.6777 11.5225 28.2218 12.0139 27.168L14.6831 21.4439C15.1745 20.3901 14.7186 19.1375 13.6648 18.6461ZM20.0089 16.0394C20.5003 14.9856 21.7529 14.5297 22.8067 15.0211C23.8605 15.5125 24.3164 16.7651 23.8251 17.8189L19.4655 27.168C18.9741 28.2218 17.7215 28.6777 16.6677 28.1864C15.6139 27.695 15.158 26.4424 15.6494 25.3886L20.0089 16.0394ZM25.4384 28.4021C26.8918 28.4021 28.07 27.2238 28.07 25.7704C28.07 24.317 26.8918 23.1388 25.4384 23.1388C23.985 23.1388 22.8067 24.317 22.8067 25.7704C22.8067 27.2238 23.985 28.4021 25.4384 28.4021Z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  );
});
